import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface MtmBreadcrumbLink {
  label: string;
  url?: string[];
  queryParams?: any;
  hidden?: boolean;
}

export interface MtmBreadcrumbLinkWithCurrentUrl extends MtmBreadcrumbLink {
  isCurrentUrl: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MtmBreadcrumbService {
  private readonly linkSubject: BehaviorSubject<MtmBreadcrumbLink[]> = new BehaviorSubject<MtmBreadcrumbLink[]>([]);
  $linkSubject: Observable<MtmBreadcrumbLink[]> = this.linkSubject.asObservable();

  constructor() {}

  setLinks(links: MtmBreadcrumbLink[]) {
    if (!links || links.length === 0) {
      return;
    }
    this.linkSubject.next(links);
  }

  clearLinks() {
    this.linkSubject.next([]);
  }
}
